/**
 * Copyright 2025-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useGetAvailablePlanActionNamesQuery } from "~/generated/graphql";

type Options = {
  skip?: boolean;
};

export function useGetAvailablePlanActionNames(options?: Options) {
  const { data, loading, error } = useGetAvailablePlanActionNamesQuery({
    fetchPolicy: "cache-and-network",
    skip: options?.skip,
  });

  return {
    data: data?.availablePlanActionNames ?? [],
    loading,
    error,
  } as const;
}
